module.exports = __webpack_public_path__ + "img/tpc-10.efd1eff1.jpg";